import { Children } from 'react';
import isComponentOfType from './isComponentOfType';
export default ((elements, Component) => {
  return Children.toArray(elements).filter(element => !isComponentOfType(element, Component));
});